/*
 * @Author: rxue
 * @Date: 2021-08-03 11:46:09
 * @LastEditors: rxue
 * @LastEditTime: 2022-06-21 17:13:03
 * @Description: 
 */
import React from 'react';
import { connect } from 'dva';
import ABSPanel from '../../../../../components/ABSPanel';
import ABSListView from '../../../../../components/ABSList/ABSListView';
import { columnsData } from './util';
import ABSPerfectScrollBar from '../../../../../components/ABSPerfectScrollBar';
import ABSLink from '../../../../../components/ABSLink';
import routeConfig from '../../../../../abs/config/routeConfig';
import commonUtils from '../../../../../utils/commonUtils';

export interface IMarketStatisticsProps {
  homePageMarketStatistics?: any;
  dispatch?: any;
}

export interface IMarketStatisticsState {

}

export function tableLink(text: string, typeId: string) {
  let link = '';
  if (typeId === '0') {
    link = `${routeConfig.productCategory}`;
  } else {
    link = `${routeConfig.productCategory}?product_type_id=${typeId}&asset_type_id=0&asset_sub_type_id=0`;
  }
  return <ABSLink target="_blank" to={link} title="跳转至细分市场">{commonUtils.formatContent(text, true, false, true, 0)}</ABSLink>;
}

class MarketStatistics extends React.Component<IMarketStatisticsProps, IMarketStatisticsState> {

  componentDidMount() {
    this.props.dispatch({
      type: 'home/getHomePageMarketStatistics',
    });
  }

  renderTitle = () => {
    return (
      <>
        今年统计
        <span className="abs-panel-title-subtitle">（单位：亿）</span>
      </>
    );
  }

  addMoreBtn() {
    return (
      <ABSLink target="_blank" to={routeConfig.marketSummary}>更多</ABSLink>
    );
  }

  render() {
    const { homePageMarketStatistics } = this.props;
    const contentData = homePageMarketStatistics ? homePageMarketStatistics : [];
    
    return (
      <ABSPanel 
        title={this.renderTitle()} 
        comment={this.addMoreBtn()} 
        removePadding={true} 
        className="abs-home-market-statistics" 
        isClearBackground={true} 
      >
        <ABSPerfectScrollBar>
          <ABSListView
            type="equal"
            columnsData={columnsData()}
            contentData={contentData}
            loading={false}
            removeBorder={true}
            bordered={true}
          />
        </ABSPerfectScrollBar>
      </ABSPanel>
    );
  }
}

function mapStateToProps({ home, global, loading }: any) {
  const { homePageMarketStatistics } = home;
  return { homePageMarketStatistics };
}

export default connect(mapStateToProps)(MarketStatistics);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/middle/MarketStatistics.tsx